<template>
    <el-dialog :title="$t(title)" :visible.sync="dialogVisible" width="600" center>
        <div class="st1 break">
            <div class="bold">{{ $t('评分规则') }}:</div>
            <div v-if="tipInfo">
                <template v-for="(tip, index) in tipInfo.content.split('\n')">
                    <template v-if="tip">
                        <div :key="index + '0'" v-if="tip.indexOf('#') == -1">
                            {{ tip }}</div>
                        <div :key="index + '1'" v-else><strong>{{ tip.split('#')[0] }}:</strong>
                            {{ tip.split('#')[1] }}</div>
                    </template>

                </template>
                <div class="bold margin-t">{{ $t('答题建议') }}:</div>
                <div>{{ $t1(tipInfo, 'extra') }}</div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" @click="dialogVisible = false">{{ $t('关闭') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "tipDialog",
    props: {
    },
    data() {
        return {
            title:'',
            tipInfo: null,
            dialogVisible: false,
        };
    },
    methods: {
        show(tag, type) {
            this.title = type
            this.$http.post("/api/tips", { tag: tag, type: type }).then((tips) => {
                this.tipInfo = tips[0];
                this.dialogVisible = true
            });
        }
    },
};
</script>
<style scoped>
.language>>>.el-dropdown-menu__item:hover {
    background: inherit !important;
}

.tag {
    color: #999;
    text-align: center;
    line-height: 20px;
    padding: 5px 15px;
    display: inline-block;
    border-radius: 15px;
    border: 1px solid #999;
}

.tag.item {
    width: 50px;
}

.tag.active {
    color: #f66;
    border: 1px solid #f66;
}

.tag.hover:hover {
    border: 1px solid #f66;
    background-color: #f66;
    color: #fff;
}
</style>